import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { trainerLectureConfirmationsApi } from "api/trainers/trainerLectureConfirmationsApi";

export const useTrainerLectureConfirmations = (
  skip: number,
  take: number,
  trainerId?: number,
  courseId?: number,
  dateFrom?: string,
  dateTo?: string,
  status?: string,
) => {
  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.TRAINER_LECTURE_CONFIRMATIONS(skip, take, trainerId, courseId, dateFrom, dateTo, status),
    queryFn: () => trainerLectureConfirmationsApi.fetch(skip, take, trainerId, courseId, dateFrom, dateTo, status),
    placeholderData: keepPreviousData,
  });

  return {
    isLoading,
    isFetching,
    confirmations: data?.data.data ?? [],
    total: data?.data.total ?? 0,
    refetch,
  };
};
